// extracted by mini-css-extract-plugin
module.exports = {"pane":"pane__2tOci","eye-catch":"eye-catch__24pn6","description":"description__3PpG_","footer":"footer__3iMqf"};